(function () {
  const outingEventsHandicapsApp = function () {
    const bindImportFromUsga = () => {
      $(document).on('click', '.import-from-usga', function (e) {
        window.stopEvent(e);

        const url = $(this).data('url');
        window.swalConfirm
          .fire({
            text: 'Import handicap index from USGA Database?',
            confirmButtonText: 'Yes',
          })
          .then((result) => {
            if (!result.isConfirmed) return;

            $('.loader.generic-loader').removeClass('d-none');
            $.ajax({
              method: 'POST',
              url,
              success: function () {
                window.location.reload();
              },
            });
          });
      });
    };

    const bindNaHandicaps = () => {
      $('.na-hdcp').on('change', function () {
        if (!$(this).prop('checked')) return;

        $(this).closest('tr').find('input[type=number]').val('');
      });
    };

    const bindChangeInputs = () => {
      $("[name*='usgas['], [name*='handicaps[']").on('change', function () {
        const thisUsga = $(this).attr('name').includes('usga');
        const scope = $(this).parent().parent();

        if (thisUsga) $(scope).find('input:not([name*=usga])').val('');
        else $(scope).find('input[name*=usga]').val('');
      });
    };

    $(document).on('turbolinks:load', () => {
      if (!$('body').hasClass('controller-outings-handicaps')) return;

      bindImportFromUsga();
      bindNaHandicaps();
      bindChangeInputs();
    });
  };

  if (typeof window !== 'undefined') {
    window.outingEventsHandicapsApp = outingEventsHandicapsApp();
  }
})();
